import React, { Component } from 'react';
import { connect } from 'react-redux';
import { salesActions } from '../../actions/sales.actions';
import { Button, Form, Label, Modal, Dropdown, FormGroup } from 'semantic-ui-react';
import { InputCoins } from '../InputCoins/InputCoins';
import { SearchBar } from '../SearchBar/SearchBar';

class ModalItensSales extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getInitialState() {
    return {
      name: '',
      type: '',
      unit_cost_price: '',
      amount_cost_price: '',
      unit_price: 0,
      currency: 'BRL',
      quantity: 1,
      amount: 25,
      part_number: '',
      openItens: false,
      submitted: false,
    };
  }

  handleChange(e, data) {
    if (data) {
      this.setState({ [data.name]: data.value });
    } else {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { sales, dispatch } = this.props;
    const {
      name,
      unit_price,
      quantity,
      amount,
      part_number,
      currency,
      type,
      unit_cost_price,
      submitted,
    } = this.state;

    if (amount && quantity && name && type) {
      let price = null;
      let costPrice = null;

      if (unit_price.toString().match(/(\.)/g)) {
        price = unit_price
          .toFixed(2)
          .toString()
          .replace(/(\.|\,)/g, '');
        price = parseInt(price);
      } else {
        price = unit_price * 100;
      }

      if (unit_cost_price && unit_cost_price.toString().match(/(\.)/g)) {
        costPrice = unit_cost_price
          .toFixed(2)
          .toString()
          .replace(/(\.|\,)/g, '');
        costPrice = parseInt(costPrice);
      } else {
        costPrice = unit_cost_price * 100;
      }

      let payload = {
        name,
        type,
        sale_id: sales.id,
        unit_price: price,
        quantity,
        currency,
        part_number,
        amount: price * quantity,
        unit_cost_price: costPrice,
        amount_cost_price: costPrice * quantity,
      };

      dispatch(salesActions.createItems(sales.id, payload)).then(() => {
        this.setState({
          submitted: false,
          openItens: false,
        });
        dispatch(salesActions.getItems(sales.id));
        this.onClose();
      });
    }
  }

  onClose() {
    const initialState = {
      name: '',
      type: '',
      unit_cost_price: 0,
      amount_cost_price: 0,
      unit_price: 0,
      currency: 'BRL',
      quantity: 1,
      amount: 25,
      part_number: '',
      openItens: false,
      submitted: false,
    };
    this.setState({
      ...initialState,
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.openItens &&
      (this.props.openItens !== prevProps.openItens || this.props.id != prevProps.id) &&
      !this.state.openItens
    ) {
      this.setState({ openItens: true });
    }
  }

  render() {
    const {
      name,
      unit_price,
      currency,
      quantity,
      part_number,
      type,
      unit_cost_price,
      submitted,
      openItens,
    } = this.state;
    const { loading } = this.props;
    const typeOptions = [
      { key: 'P', value: 'P', text: 'Produto' },
      { key: 'S', value: 'S', text: 'Serviço' },
    ];

    return (
      <Modal size="small" open={openItens} closeIcon onClose={() => this.onClose()}>
        <Modal.Header>Cadastro de novo Item</Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleSubmit} loading={loading}>
            <Form.Field>
              <label>Produto</label>
              <SearchBar
                onSelect={(item) =>
                  this.setState({
                    part_number: item.part_number,
                    name: item.name,
                  })
                }
              />
            </Form.Field>
            <Form.Field>
              <label>Tipo</label>
              <Dropdown
                placeholder="Tipo"
                fluid
                search
                selection
                name="type"
                options={typeOptions}
                onChange={(event, data) => this.handleChange(true, data)}
                value={type}
              />
              {submitted && !type && (
                <Label basic color="red" pointing>
                  Tipo é requerido
                </Label>
              )}
            </Form.Field>
            <Form.Field>
              <label>Part Number</label>
              <input
                name="part_number"
                placeholder="Nº do Produto"
                value={part_number}
                onChange={this.handleChange}
              />
            </Form.Field>
            {submitted && !part_number && (
              <Label basic color="red" pointing>
                Part Number é requerido
              </Label>
            )}
            <Form.Field>
              <label>Descrição</label>
              <input
                name="name"
                placeholder="Descrição"
                value={name}
                onChange={this.handleChange}
              />
              {submitted && !name && (
                <Label basic color="red" pointing>
                  Descrição é requerido
                </Label>
              )}
            </Form.Field>
            <FormGroup>
              <Form.Field width={6}>
                <label>Preço Custo</label>
                <InputCoins
                  name={'unit_cost_price'}
                  amount={unit_cost_price}
                  currency={currency}
                  onChange={this.handleChange}
                />
              </Form.Field>
              <Form.Field width={6}>
                <label>Preço Venda</label>
                <InputCoins
                  name={'unit_price'}
                  amount={unit_price}
                  currency={currency}
                  onChange={this.handleChange}
                />
                {submitted && !unit_price && (
                  <Label basic color="red" pointing>
                    Preço Venda é requerido
                  </Label>
                )}
              </Form.Field>
              <Form.Field width={4}>
                <label>Quantidade</label>
                <input
                  name="quantity"
                  placeholder="Quantidade"
                  type="number"
                  value={quantity}
                  onChange={this.handleChange}
                />
                {submitted && !quantity && (
                  <Label basic color="red" pointing>
                    Quantidade é requerido
                  </Label>
                )}
              </Form.Field>
            </FormGroup>
            <Button
              primary
              type="submit"
              disabled={!unit_price && !quantity && !name && !part_number ? true : false}>
              Criar
            </Button>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const { sales, orders } = state;
  return {
    sales: sales.item,
    itemsType: orders.itemsType || null,
    loading: sales.loading || false,
  };
}

const connectedModalItensSales = connect(mapStateToProps)(ModalItensSales);
export { connectedModalItensSales as ModalItensSales };
